import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import Vue from 'vue';
import Router from 'vue-router'; // import utils from '../utils/utils'

Vue.use(Router);
var routes = [{
  path: '/',
  name: 'login',
  component: function component() {
    return import('@/views/login/index');
  },
  alias: '/login',
  meta: {
    title: '登录'
  }
}, {
  path: '/login/bindPhone',
  name: 'bindPhone',
  component: function component() {
    return import('@/views/bindPhone');
  },
  meta: {
    title: '绑定手机号'
  }
}, {
  path: '/login/retrievePsw',
  name: 'retrievePsw',
  component: function component() {
    return import('@/views/retrievePsw');
  },
  meta: {
    title: '找回密码'
  }
}, {
  path: '/logout',
  name: 'logout',
  component: function component() {
    return import('@/views/logResout');
  },
  meta: {
    title: '退出登录'
  }
}, {
  path: '/login/loginSuccess',
  name: 'loginSuccess',
  component: function component() {
    return import('@/views/logResout');
  },
  meta: {
    title: '登录成功'
  }
},
/* 双因子页面 */
{
  path: '/login/doubleVerify',
  name: 'doubleVerify',
  component: function component() {
    return import('@/views/doubleVerify');
  },
  meta: {
    title: '双因子验证'
  }
},
/* 二次认证-实人认证页面 */
{
  path: '/login/secondaryCertification',
  name: 'secondaryCertification',
  component: function component() {
    return import('@/views/secondaryCertification');
  },
  meta: {
    title: '认证服务'
  }
},
/* 二次认证-实人认证页面 */
{
  path: '/login/faceRecognition',
  name: 'faceRecognition',
  component: function component() {
    return import('@/views/secondaryCertification/faceRecognition');
  },
  meta: {
    title: '实人认证'
  }
},
/* 二次认证-短信认证页面 */
{
  path: '/login/phoneRecognition',
  name: 'phoneRecognition',
  component: function component() {
    return import('@/views/secondaryCertification/phone');
  },
  meta: {
    title: '短信认证服务'
  }
},
/* 二次认证-龙key认证页面 */
{
  path: '/login/longKeyRecognition',
  name: 'longKeyRecognition',
  component: function component() {
    return import('@/views/secondaryCertification/longKey');
  },
  meta: {
    title: '龙key认证服务'
  }
},
/* 二次认证-推送待办 */
{
  path: '/login/remindCertification',
  name: 'remindCertification',
  component: function component() {
    return import('@/views/remindCertification/index');
  },
  meta: {
    title: ' 二次认证至推送待办'
  }
},
/* 账号探活待办页面 */
{
  path: '/login/oaProbe',
  name: 'oaProbe',
  component: function component() {
    return import('@/views/todos/oaProbeTodo');
  },
  meta: {
    title: '外部账号续期验证'
  }
},
/* 弱密码、首登修改密码 */
{
  path: '/login/modifyPassword',
  name: 'modifyPassword',
  component: function component() {
    return import('@/views/modifyPassword');
  },
  meta: {
    title: '修改密码'
  }
},
/* 弱密码、首登修改密码成功页面 */
{
  path: '/login/modifyResult',
  name: 'modifyResult',
  component: function component() {
    return import('@/views/modifyPassword/modifyResult');
  },
  meta: {
    title: '修改密码'
  }
}, {
  path: '/login/forgetPsw',
  name: 'forgetPsw',
  component: function component() {
    return import('@/views/buttJoint');
  },
  meta: {
    title: '修改密码'
  }
}, // 供应商注册页
{
  path: '/login/registered',
  name: 'Registered',
  component: function component() {
    return import('@/views/registered');
  },
  meta: {
    title: '注册'
  }
}, {
  path: '*',
  name: '404',
  component: function component() {
    return import('@/views/404.vue');
  }
}];
/**
 * @func 路由守卫
 */

var router = new Router({
  mode: 'history',
  base: '/cas/new',
  routes: routes
});
router.beforeEach(function (to, from, next) {
  if (to.meta.title) {
    document.title = to.meta.title;
  } // if (utils.isMobile()) {
  //   window.location.href = utils.getSsoUrl()
  // }


  next();
});
export default router;